<script>
	let classes = '';
	export { classes as class };
	export let kind = '';
	export let label = '';

	/** @type {import('@resider/types').Sizing} */
	export let size = 'md';
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<span class="badge {kind} {size} {classes}" data-testid="badge" on:click on:keydown>
	{#if $$slots.left}
		<span class="left">
			<slot name="left" />
		</span>
	{/if}
	{#if $$slots.default || label}
		<span class="label">
			<slot>
				{label}
			</slot>
		</span>
	{/if}
	{#if $$slots.right}
		<span class="right">
			<slot name="right" />
		</span>
	{/if}
</span>

<style>.badge{color:hsla(var(--hsl-badge-text, var(--hsl-white)));background:hsla(var(--hsl-badge-background, var(--hsl-primary)));display:inline-grid;align-items:center;justify-items:center;place-items:center;font-weight:600!important}.black{--hsl-badge-background:var(--hsl-black)}.success{--hsl-badge-background:var(--hsl-success)}.error{--hsl-badge-background:var(--hsl-error)}.warning{--hsl-badge-background:var(--hsl-warning)}.success-alt{--hsl-badge-background:var(--hs-success), calc(var(--l-success) - 20%)}.sm,.xs{font:var(--f-ui-xs-medium);gap:var(--space-xxs)}.xs{border-radius:1rem;padding:.125rem .25rem;min-width:1.125rem;max-height:1.125rem}.sm{border-radius:.75rem;min-width:1.425rem;padding:.25rem .375rem}.md{border-radius:.625rem;font:var(--f-ui-sm-medium);gap:.375rem;padding:.375rem .5rem}.lg{border-radius:.75rem;font:var(--f-ui-md-medium);gap:.5rem;padding:.5rem .75rem}</style>
